'use client';

import * as React from 'react';

import { PricingFAQ } from '@workspace/billing/components/pricing-faq';
import { PricingIncludes } from '@workspace/billing/components/pricing-includes';
import { PricingLaunchBanner } from '@workspace/billing/components/pricing-launch-banner';
import { PricingPageHero } from '@workspace/billing/components/pricing-page-hero';
import { PricingTable } from '@workspace/billing/components/pricing-table';

import { trackCta } from '~/lib/track-cta';

// Same real customer quote shown in-app, on the recommended card.
const FEATURED_TESTIMONIAL = {
  quote:
    'VideoMule created a 99% accurate script on the first try — really impressed. I tried a lot of similar apps, including Guidde and Descript.',
  name: 'Wynus'
};

/**
 * Public /pricing page: the same redesigned, config-driven pricing as the
 * in-app page (correct monthly + annual prices, Creator/Team/Agency), so it
 * never drifts from the app. Cards link to sign-up (no `onUpgrade`).
 */
export function MarketingPricingShowcase(): React.JSX.Element {
  React.useEffect(() => {
    trackCta('pricing_viewed', { surface: 'pricing_page' });
  }, []);

  return (
    <div className="flex flex-col">
      <PricingLaunchBanner />
      <PricingPageHero />
      <div className="container py-8">
        <PricingTable
          recommendedProductId="plus"
          featuredTestimonial={FEATURED_TESTIMONIAL}
          onPlanCtaClick={(productId, planId, interval) =>
            trackCta('plan_cta_clicked', {
              product_id: productId,
              plan_id: planId,
              interval,
              surface: 'pricing_page'
            })
          }
        />
      </div>
      <PricingIncludes />
      <PricingFAQ />
    </div>
  );
}
